export default __webpack_public_path__ + "static/media/svg1.b885b6dc.svg";